import React, { useContext } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../../firmwareState/firmwareContext';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './UnassignedFirmwareCheckBox.module.scss';

const UnassignedFirmwareCheckBox: React.FC = () => {
	const { toggleUnassignedFirmware, isUnassignedFirmware } = useContext<IFirmwareContext>(FirmwareContext);

	return (
		<Checkbox
			className={style.container}
			onChange={toggleUnassignedFirmware}
			checked={isUnassignedFirmware}
			data-test="UnassignedFirmwareCheckBox">
			<Text translationNameSpace="listing" translationKey="unassignedFirmwareLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedFirmwareCheckBox;
